export default __webpack_public_path__ + "static/media/supplier.fe18a773.svg";